import { IConfigsType } from '../../types'

const ghaiPopCorporateIntraday: IConfigsType = {
  ghai_pop: {
    '/:brand/hourly_sales': {
      variables: ['corporateGroup', 'ghaiPopLocationIntradayConfigs'],
      groupFilter: {
        api: 'corporateFilter',
      },
      dateFilter: {
        types: [
          'week',
          'period',
          'quarter',
          'year',
          'last_week',
          'this_week',
          'yesterday',
          'trailing_7_days',
          'custom',
        ],
        defaultType: 'last_week',
      },
      reportTitle: {
        type: 'title',
        title: 'Hourly Sales',
      },
      dayOfWeekSelector: {
        type: 'select',
        value: 'intradayDayOfWeekOptions.value',
        onChange: 'intradayDayOfWeekOptions.onChange',
        options: 'intradayDayOfWeekOptions.options',
        label: 'Day Of Week',
        multiple: true,
      },
      hoursSelector: {
        type: 'select',
        value: 'intradayHoursOptions.value',
        onChange: 'intradayHoursOptions.onChange',
        options: 'intradayHoursOptions.options',
        label: 'Hours',
        multiple: true,
      },
      revenueCenterSelector: {
        type: 'select',
        value: 'intradayRevenueCenterMetricOptions.value',
        onChange: 'intradayRevenueCenterMetricOptions.onChange',
        options: 'intradayRevenueCenterMetricOptions.options',
        label: 'Revenue Center',
        width: '400px',
      },

      downloadCsv: {
        type: 'download-csv',
        api: 'fwWingstopLocationIntraday',
        fileName: 'location-intraday-report',
        message: 'Download as CSV',
        fields: [
          {
            key: '<%- JSON(corporateGroup?.tableColumns.slice(0, 1)) %>',
            hide: '<%- _.isUndefined(corporateGroup?.tableColumns) %>',
          },
          {
            key: '<%- JSON(intradayCsvColumns.price) %>',
            hide: '<%- _.isUndefined(intradayCsvColumns.price) %>',
          },
          {
            key: '<%- JSON(intradayCsvColumns.number) %>',
            hide: '<%- _.isUndefined(intradayCsvColumns.number) %>',
          },
          {
            key: '<%- JSON(intradayCsvColumns.percent) %>',
            hide: '<%- _.isUndefined(intradayCsvColumns.percent) %>',
          },
        ],
      },

      intradayTable: {
        type: 'table-v2',
        api: 'fwWingstopLocationIntraday',
        pagination: {
          pageSize: 30,
        },
        columns: [
          {
            key: '<%- JSON(corporateGroup?.tableColumns.slice(0, 1)) %>',
            hide: '<%- _.isUndefined(corporateGroup?.tableColumns) %>',
            width: '200px',
            sortable: true,
          },
          {
            key: '<%- JSON(intradayTableColumns.price) %>',
            hide: '<%- _.isUndefined(intradayTableColumns.price) %>',
          },
          {
            key: '<%- JSON(intradayTableColumns.number) %>',
            hide: '<%- _.isUndefined(intradayTableColumns.number) %>',
          },
          {
            key: '<%- JSON(intradayTableColumns.percent) %>',
            hide: '<%- _.isUndefined(intradayTableColumns.percent) %>',
          },
        ],
      },

      chatbox: {
        type: 'chatbox-v2',
        agentCode: 'hourly-sales',
        sendStoreId: false,
        hideFromNonExpoUsers: true,
      },
    },
  },
}

export default ghaiPopCorporateIntraday
